
        import Symbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-rescls-collector_project",
  "use": "icon-rescls-collector_project-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-rescls-collector_project\"><path d=\"M14 24H2c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h12c.6 0 1 .4 1 1v22c0 .6-.4 1-1 1\" style=\"fill:#3498db\" /><path d=\"M5 1h6v1H5zM3 3h10v17H3z\" style=\"fill:#fff\" /><circle cx=\"8\" cy=\"22\" r=\"1\" style=\"fill:#fff\" /><path d=\"M22 24H12c-.6 0-1-.4-1-1V13c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v10c0 .6-.4 1-1 1\" style=\"fill:#dce8f3\" /><path d=\"M17 17.6c-1 0-2.8 1.2-2.8 3.1 0 2 2.1.5 2.8.5s2.8 1.4 2.8-.5-1.8-3.1-2.8-3.1M18.668 14.261c-.486-.102-1 .385-1.147 1.088s.128 1.355.614 1.457c.487.102 1-.385 1.147-1.088.148-.702-.127-1.355-.614-1.457M20.594 16.538c-.399-.19-.934.1-1.196.648s-.151 1.147.248 1.337.934-.1 1.196-.648.151-1.147-.248-1.337M16.487 15.422c-.147-.703-.661-1.19-1.147-1.088s-.761.754-.614 1.457.661 1.19 1.147 1.088.761-.754.614-1.457M14.62 17.14c-.262-.548-.797-.838-1.196-.648s-.51.789-.248 1.337.797.838 1.196.648.51-.789.248-1.337\" style=\"fill:#00b066\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-rescls-collector_project"/>
                </svg>
            );
        };

        Icon.id = "icon-rescls-collector_project";

        export default Icon;
    